import * as React from 'react';
import { Radio } from '@arco-design/web-react';

const RadioGroup = Radio.Group;

// Segmented control for picking the email editor mode (Visual / Code). These are
// mutually-exclusive modes, so an inline control showing all options with the
// current one selected is the right pattern. Each action carries a `value` (the
// editor constant) and a `select()` callback; `value` highlights the active mode.
export default function EditorSpeedSelector({ actions, value }) {
  const handleChange = (newValue) => {
    if (newValue == null) return; // keep one mode active
    const action = actions.find((a) => a.value === newValue);
    if (action) action.select();
  };

  return (
    <RadioGroup
      type="button"
      size="small"
      value={value}
      onChange={handleChange}
      aria-label="Choose editor mode"
      style={{ margin: "8px 0" }}
    >
      {actions.map((action) => (
        <Radio key={action.name} value={action.value}>
          {action.icon}
          <span style={{ marginLeft: 6 }}>{action.name}</span>
        </Radio>
      ))}
    </RadioGroup>
  );
}
